import { render, staticRenderFns } from "./SelectedNanogenreTitles.vue?vue&type=template&id=12597a1e&scoped=true&"
import script from "./SelectedNanogenreTitles.vue?vue&type=script&lang=js&"
export * from "./SelectedNanogenreTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12597a1e",
  null
  
)

export default component.exports